import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { FatTemplate, FatTemplateImportStatus } from '../models/models';

@Injectable({
  providedIn: 'root'
})
export class FatTemplateService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}/fat-template`;

  getLatestTemplate(): Observable<FatTemplate> {
    return this.http.get<FatTemplate>(`${this.apiUrl}/latest`);
  }

  hasValidatedTemplate(): Observable<{ hasValidated: boolean }> {
    return this.http.get<{ hasValidated: boolean }>(`${this.apiUrl}/has-validated`);
  }

  getVersions(): Observable<string[]> {
    return this.http.get<string[]>(`${this.apiUrl}/versions`);
  }

  getByVersion(version: string): Observable<FatTemplate> {
    return this.http.get<FatTemplate>(`${this.apiUrl}/${version}`);
  }

  saveNewVersion(template: FatTemplate): Observable<FatTemplate> {
    return this.http.post<FatTemplate>(this.apiUrl, template);
  }

  updateTemplate(version: string, template: FatTemplate): Observable<FatTemplate> {
    return this.http.put<FatTemplate>(`${this.apiUrl}/${version}`, template);
  }

  validateTemplate(version: string): Observable<FatTemplate> {
    return this.http.post<FatTemplate>(`${this.apiUrl}/${version}/validate`, {});
  }

  startImport(file: File): Observable<FatTemplateImportStatus> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post<FatTemplateImportStatus>(`${this.apiUrl}/import`, formData);
  }

  getImportStatus(jobId: number): Observable<FatTemplateImportStatus> {
    return this.http.get<FatTemplateImportStatus>(`${this.apiUrl}/import/${jobId}`);
  }

  exportTemplate(version: string): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/${version}/export`, {
      responseType: 'blob'
    });
  }
}
